<template>
	<el-row id="product" class="container">
		<div class="product-wrapper">
			<el-col :span="22" :offset="1">
				<el-row class="text-left">
					<h1 class="title" v-text="content.title"></h1>
				</el-row>
				<el-row>
					<div class="gallery">
						<flickity ref="flickity" :options="flickityOptions">
							<template v-for="img in content.images">
								<div class="carousel-cell">
									<img :src="transpileImage(img.src)" alt="" />
								</div>
							</template>
						</flickity>
					</div>
				</el-row>
				<el-row>
					<el-col :span="11" class="text-left">
						<div class="body" v-html="content.body"></div>
					</el-col>
					<el-col :span="12" :offset="1" class="aside">
						<div v-if="this.videoSrc" class="video">
							<video controls>
								<source :src="this.videoSrc" type="video/mp4" />
							</video>
						</div>
					</el-col>
				</el-row>
			</el-col>
		</div>
	</el-row>
</template>

<script>

	import Flickity from 'vue-flickity';
	import 'flickity-imagesloaded';

	const URL = 'https://app.scada.pt'

	export default {
		components: {
        	Flickity
    	},
		data() {
			return{
				category: this.$route.params.category,
				subcategory: this.$route.params.subcategory,
				subsubcategory: this.$route.params.subsubcategory,
				slug: this.$route.params.product,
				flickityOptions: {
					initialIndex: 0,
	                prevNextButtons: false,
	                pageDots: false,
	                cellAlign: 'center',
	                autoPlay: 4000,
	                pauseAutoPlayOnHover: false,
	                contain: true,
	                setGallerySize: false,
	                imagesLoaded: true
				},
				isLocalhost: Boolean(window.location.hostname === 'localhost' || 
					window.location.hostname === '[::1]' ||
					window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/) )
			}
		},
		computed : {
			content () {

				let category = this.$store.getters.content[this.category];

				if( this.subcategory ){
					if(this.subsubcategory){
						return category.children[this.subcategory].children[this.subsubcategory].products[this.slug]
					}else{
						return category.children[this.subcategory].products[this.slug]
					}
				}else{
					return category.products[this.slug]
				}
			},
			videoSrc () {

				let src = '';

				if( this.category === 'cadeiras-elevador' )
					src = this.category

				if( this.slug === 'pool-star' ||  this.slug === 'v64' ||
					this.slug === 'v65' || this.slug === 'plg7' || 
					this.slug === 'plk8' || this.slug === 'silver' ||
					this.slug === 'angular' || this.slug === 'e07-easy-move' ||
					this.slug === 'serie-lr' || this.slug === 'serie-vm' ||
					this.slug === 'sl-250' || this.slug === 'steppy' || 
					this.slug === 't09-roby' || this.slug === 'e10-ecovimec' )
					src = this.slug


				// if( this.isLocalhost ){
					return ( src ) ? '/static/vids/' + src + '.mp4' : false					
				// }else{
				// 	return ( src ) ?  URL + '/static/vids/' + src + '.mp4' : false
				// }
			}
		},
		methods: {
			transpileImage ( src ) {
				return ( this.isLocalhost ) ? src : src.replace( 'https://www.scada.pt/wp-content', '')				
			}
		},
		created() {
			this.$store.commit('ON_PRODUCT_VIEW');
		},
		mounted () {
			this.$nextTick(function () {
			})
		}
	}
</script>

<style lang="less">

	#product{
		position: relative;
		height: ~"calc(100% - 215px)";

		.el-col-offset-1{
			margin-bottom: 25px;
		}

		.product-wrapper{
			height: 100%;
			overflow-y: scroll;
			-webkit-overflow-scrolling: touch;
		}
	}

	.title{
		margin: 0 0 17px;
	}

	.gallery{
		position: relative;
		margin-bottom: 2.083335%;
		width: 100%;
		height: 400px;
		overflow: hidden;

		.carousel-cell{
			height: 400px;
			padding-right: 5px;

			&:last-child{
				padding-right: 0px;
			}

			img{
				max-height: 400px;
			}
		}
	}

	.flickity-viewport {
		transition: height 0.2s;
	}

	.video{
		width: 100%;
		max-width: 100%;
		margin-bottom: 30px;
		
		video{
			width: 100%;
			height: auto;
		}
	}

	.aside{
		margin-top: 15px;
	}


</style>




// WEBPACK FOOTER //
// Product.vue?15de54b9